module.exports = __webpack_public_path__ + "static/media/menu.d9954032.svg";